<template>
  <div class="extras">

    <div class="title-button">

      <h1>Extras</h1>
      <router-link to="/extras/create" class="button p-3" v-if="userRole == 1">New extra</router-link>

    </div>

    <div class="box">

      <form @submit.stop.prevent="doSearch" class="box__header form--inline">
        <input v-model="quickSearch" type="search" placeholder="Quick search">
        <button class="button button--small" type="submit">Search</button>
      </form>

      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="editExtra"
        @delete="deleteExtra"
        @viewInstance="viewInstance"
        >
      </vdtnet-table>

    </div><!-- box -->

  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
// import moment from 'moment'
export default {
  name: 'extras',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    },
  },
  created () {
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'extras/table',
          headers: {
            'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
      },
      fields: {
        name: {
          label: 'Name'
        },
        price: {
          label: 'Price',
          render: (data) => {
            return `£${ data }`
          }
        },
        cost: {
          label: 'Cost',
          render: (data) => {
            return (data !== null ?  `£${ data }` : '')
          }
        },
        edit: {
          searchable: false,
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            return `<a href="/extras/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        },
        delete: {
          searchable: false,
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            if (this.userRole == 1) {
              return `<a href="/extras/${ row.id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
            } else {
              return ''
            }
          }
        }
      },
      quickSearch: ''
    }
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    editExtra(data) {
      this.$router.push({ name: 'extra-edit', params: { id: data.id }})
    },
    deleteExtra(data) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'extras/' + data.id + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$refs.table.reload()
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}

</script>
